(function (window) {
    'use strict';
    var MAP = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;'};
    function esc(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return MAP[c]; });
    }
    window.JN = window.JN || {};
    window.JN.esc = esc;
})(window);
